const routes = [
  {
    path: '/contact-lists/categories',
    name: 'contactLists-categories-list',
    component: () => import(/* webpackChunkName: "page/contact-lists/categories/list" */'@/views/pages/contact-lists/categories/List'),
    meta: {
      permissions: 'contact_list_categories_read'
    }
  },
  {
    path: '/contact-lists/categories/new',
    name: 'contactLists-categories-new',
    component: () => import(/* webpackChunkName: "page/contact-lists/categories/new" */'@/views/pages/contact-lists/categories/New'),
    meta: {
      permissions: 'contact_list_categories_write'
    }
  },
  {
    path: '/contact-lists/categories/:id',
    name: 'contactLists-categories-single',
    component: () => import(/* webpackChunkName: "page/contact-lists/categories/single" */'@/views/pages/contact-lists/categories/Single'),
    meta: {
      permissions: 'contact_list_categories_read'
    }
  },
  {
    path: '/contact-lists/categories/:id/edit',
    name: 'contactLists-categories-edit',
    component: () => import(/* webpackChunkName: "page/contact-lists/categories/edit" */'@/views/pages/contact-lists/categories/Edit'),
    meta: {
      permissions: 'contact_list_categories_write'
    }
  }
]

export default routes
